import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../hooks';
import { CmdArea } from '../../common/CmdArea';
import { Number } from '../../common/Number';
import { zigbeeImageNotify } from '../../../../actions/zigbee/commands/OTA/ZigbeeImageNotify';
const CmdImageNotify = (props) => {
    const [jitter, setJitter] = useState(100);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeImageNotify(props.nid, props.eid, { jitter }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Jitter ", _jsx(Number, { value: jitter, setValue: setJitter })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Image Notify" })] }));
};
export const CommandsOTA = props => {
    return (_jsx(React.Fragment, { children: _jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '1em' }, children: _jsx(CmdImageNotify, Object.assign({}, props)) }) }));
};
